export const AnimatedEmojisList = [
  '1f922',
  '263a',
  '264b',
  '1f37f',
  '1f925',
  '1f4a9',
  '264e',
  '1f6b2',
  '1f913',
  '1f98b',
  '1f98e',
  '1f914',
  '1f97a',
  '1f4a7',
  '1fac0',
  '1f4b8',
  '1f92e',
  '1f940',
  '1f978',
  '1f31c',
  '1f382',
  '1f92b',
  '1f340',
  '1fae5',
  '1f971',
  '1f44e_1f3fb',
  '1f985',
  '1fae2',
  '1f3f3',
  '1f44e_1f3fe',
  '1f976',
  '1f915',
  '1f98d',
  '1f4a1',
  '1f912',
  '1f924',
  '1f483_1f3ff',
  '264d',
  '1f94f',
  '1f923',
  '264c',
  '1fae3',
  '1facf',
  '1f44e_1f3fd',
  '1f4aa',
  '1f379',
  '1fae4',
  '1f327',
  '1f984',
  '1f91e',
  '1f970',
  '1f44e_1f3fc',
  '1f4af',
  '1f383',
  '1f31b',
  '1f979',
  '1f377',
  '1f92c',
  '1f31e',
  '1f941',
  '1f92d',
  '1f6ae',
  '270c',
  '1fa87',
  '1f60c',
  '1f64f_1f3fe',
  '1f498',
  '1f60d',
  '1f64f_1f3fb',
  '1f91e_1f3fb',
  '1f3f8',
  '1f63b',
  '1f91e_1f3fe',
  '1f496',
  '1f63e',
  '1f604',
  '1f409',
  '2764',
  '2753',
  '1f603',
  '2699',
  '1f577',
  '1f407',
  '1f635',
  '1f49f',
  '1f438',
  '1f49a',
  '1f632',
  '1f400',
  '1f91e_1f3fd',
  '270c_1f3ff',
  '1f63d',
  '1f463',
  '1f497',
  '1f91e_1f3fc',
  '1f63c',
  '1f40a',
  '1f499',
  '1fa75',
  '2744',
  '1fa81',
  '1f32a',
  '1f60e',
  '1f64f_1f3fc',
  '1f9e1',
  '1f60b',
  '1f64f_1f3fd',
  '1f633',
  '1f634',
  '1f602',
  '1f605',
  '1f618',
  '1f9a6',
  '1f627',
  '1f415',
  '1f3b0',
  '1f3d5',
  '1f48c',
  '1f412',
  '1f620',
  '1f44f_1f3fe',
  '1f629',
  '1f424',
  '1f616',
  '2763',
  '1f44f_1f3fb',
  '1f44f',
  '1f611',
  '1f423',
  '1f54a',
  '1f41b',
  '1f483',
  '1f41e',
  '1f642',
  '1f5a4',
  '1f3d2',
  '1f680',
  '1f42c',
  '1f61a',
  '1f64c_1f3fe',
  '26be',
  '1f44d_1f3fc',
  '1f64c_1f3fb',
  '1f61f',
  '1f44d_1f3fd',
  '1f635_200d_1f4ab',
  '1f3af',
  '1f44f_1f3fc',
  '1f422',
  '1f610',
  '1f628',
  '1f44f_1f3fd',
  '1f617',
  '1f425',
  '1f621',
  '1f47f',
  '1f413',
  '1f9a0',
  '1f48b',
  '1f619',
  '1f3b6',
  '1f48e',
  '1f9a7',
  '1f64c',
  '1f626',
  '1f9bf',
  '1f64c_1f3fc',
  '1f42e',
  '1f440',
  '1f44d_1f3fe',
  '1f64c_1f3fd',
  '26bd',
  '1f44d_1f3fb',
  '1f62f',
  '1f41d',
  '1f643',
  '1f3d3',
  '1f41c',
  '1f644',
  '1f62a',
  '261d_1f3fb',
  '261d_1f3fe',
  '1f193',
  '1f4aa_1f3ff',
  '1f30f',
  '1f30a',
  '2650',
  '1f44b_1f3fd',
  '1f44b_1f3fc',
  '1f6eb',
  '1f308',
  '1f339',
  '1f4f8',
  '2651',
  '1faab',
  '1f998',
  '23f0',
  '261d_1f3fd',
  '1f192',
  '1f996',
  '261d_1f3fc',
  '1f195',
  '1fabc',
  '1f35c',
  '1fab3',
  '1f6ec',
  '1f99f',
  '1f44b_1f3fb',
  '1f50b',
  '1f35d',
  '1f331',
  '1f44b_1f3fe',
  '1f99a',
  '1f381',
  '1f92a',
  '1f386',
  '1f988',
  '2764_200d_1fa79',
  '1fae8',
  '1f92f',
  '1fae1',
  '1f44e_1f3ff',
  '1f975',
  '1f343',
  '1fae6',
  '1f972',
  '2648',
  '1f388',
  '1f6a7',
  '1f483_1f3fd',
  '264f',
  '1f37b',
  '1f483_1f3fc',
  '1f94d',
  '1f921',
  '1f38a',
  '1f37e',
  '264a',
  '1f917',
  '1f62e_200d_1f4a8',
  '1f6a9',
  '1f928',
  '1f910',
  '2615',
  '1fae7',
  '1f514',
  '1f342',
  '1f987',
  '1f389',
  '1f973',
  '2649',
  '1f345',
  '1fae0',
  '1f4ab',
  '1f974',
  '1f980',
  '1f525',
  '2604',
  '1f31f',
  '1f373',
  '203c',
  '1f942',
  '1f911',
  '1f916',
  '1f4a5',
  '1f6a8',
  '1f929',
  '1f483_1f3fb',
  '1f920',
  '1f94e',
  '1f927',
  '1f483_1f3fe',
  '1f52e',
  '1f600',
  '1f607',
  '2757',
  '1f638',
  '1f49b',
  '2795',
  '1f631',
  '1f3c1',
  '1f636',
  '1f49e',
  '1f415_200d_1f9ba',
  '1f609',
  '1fa83',
  '1fa77',
  '1f43e',
  '1f64f_1f3ff',
  '1f91e_1f3ff',
  '1f3cf',
  '1f441',
  '1f495',
  '270c_1f3fd',
  '1f40d',
  '1f63f',
  '1f63a',
  '270c_1f3fc',
  '1f40c',
  '1f49d',
  '1f405',
  '1f637',
  '1f608',
  '1f630',
  '1f402',
  '1f49c',
  '1f606',
  '1f639',
  '1f433',
  '1f601',
  '1f493',
  '2705',
  '270c_1f3fb',
  '1f40e',
  '2764_200d_1f525',
  '270c_1f3fe',
  '1fa78',
  '1f494',
  '1f6ce',
  '26ce',
  '1f3f4',
  '1fa85',
  '1f60a',
  '261d',
  '1fa76',
  '270f',
  '1f60f',
  '1f9ae',
  '1f62d',
  '1f641',
  '1f3d1',
  '1f62c',
  '1f480',
  '1f329',
  '2602',
  '1f61e',
  '1f61b',
  '1f64c_1f3ff',
  '1f648',
  '1f3b3',
  '1f47d',
  '1f623',
  '1f64f',
  '2696',
  '1f429',
  '1f64a',
  '1f416',
  '1f624',
  '1f3a2',
  '1f43f',
  '1f612',
  '1f44e',
  '1f426_200d_2b1b',
  '1f44f_1f3ff',
  '1f615',
  '1f44b',
  '1f61c',
  '274c',
  '1f649',
  '1f9be',
  '1f9d0',
  '1f61d',
  '1f44d_1f3ff',
  '1f62b',
  '1f3bb',
  '2728',
  '1f9ad',
  '1f640',
  '1f62e',
  '1f3be',
  '1f419',
  '1f426',
  '1f614',
  '2049',
  '1f613',
  '1f44d',
  '1f421',
  '26a1',
  '1f47b',
  '1f625',
  '1f3b2',
  '1f410',
  '1f622',
  '1fab1',
  '1faa9',
  '1f305',
  '261d_1f3ff',
  '1f4f4',
  '1fabf',
  '1f636_200d_1f32b',
  '1f90e',
  '1f4aa_1f3fb',
  '1f30b',
  '2653',
  '1f393',
  '1f199',
  '1f30e',
  '1f4aa_1f3fe',
  '2639',
  '1f304',
  '1f44b_1f3ff',
  '1fab0',
  '1f198',
  '1f4aa_1f3fd',
  '1f30d',
  '1f32c',
  '2652',
  '1f4aa_1f3fc',
  '1f995',
  '1f90d',
  '1f6f8',
];
